import styled from "styled-components";
import { useTheme } from "src/apps/providers/ThemeStore";

interface AvatarProps {
  width?: string;
}

export const Avatar = ({ width = "3.438rem" }: AvatarProps) => {
  const { companyLogo, isCustomizationLoaded } = useTheme();

  // Never show the default logo when the customer's customization is unknown (e.g. it failed)
  if (!companyLogo || !isCustomizationLoaded) return null;
  return <ImgContainer src={companyLogo} $width={width} />;
};

const ImgContainer = styled.img<{ $width: string }>`
  width: ${({ $width }) => $width};
  aspect-ratio: 1;
  border-radius: 1.75rem;
`;
